(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bf-product-coupon"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-bf-copy]');
  if (!button || button.disabled) return;
  const original = button.textContent;
  button.disabled = true;
  let copied = false;
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(button.dataset.bfCopy);
      copied = true;
    }
  } catch (error) { /* Try the selection-based clipboard fallback below. */ }
  if (!copied) {
    const field = document.createElement('textarea');
    field.value = button.dataset.bfCopy;
    field.readOnly = true;
    field.style.cssText = 'position:fixed;left:-9999px;top:0;';
    document.body.appendChild(field);
    field.select();
    try { copied = document.execCommand('copy'); } catch (error) { copied = false; }
    field.remove();
    button.focus({ preventScroll: true });
  }
  button.textContent = copied ? button.dataset.copiedLabel : button.dataset.errorLabel;
  setTimeout(function () {
    button.textContent = original;
    button.disabled = false;
  }, 2000);
});
  } catch(e) { console.error(e); }
})();

})();
